import { EmployeeItem } from '../bus/employee/types';
import $axios from '../utils/axios-instance';

export default class EmployeesApi {
  async getEmployeeList() {
    return await $axios
      .get<{ data: EmployeeItem[] }>('/v1/Employee')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getEmployeeDetail(data: { id: number | string }) {
    return await $axios
      .get<EmployeeItem>(`/v1/Employee/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createEmployee(data: Omit<EmployeeItem, 'id'>) {
    return await $axios
      .post('/v1/Employee', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeEmployee(data: EmployeeItem) {
    return await $axios
      .put(`/v1/Employee/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteEmployee(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/Employee/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
